export enum PageId {
  CorePDP = "CorePdp",
  LatPDP = "LatPdp",
  PDP = "PDP",
  Gallery = "Gallery",
  ChecksQuickView = "QuickViewAtc",
  RecommendationLane = "RecommendationLane",
  RecommendationLaneWithQuantity = "RecommendationLaneWithQuantity",
  PDC = "PDC",
  QuickEditor = "QuickEditor",
  Cart = "Cart",
  PpagProductTile = "PpagProductTile",
  Category = "Category",
  Checkout = "Checkout",
  OrderConfirmation = "OrderConfirmation",
  HomePage = "HomePage",
  SearchPages = "SearchPages",
  SearchDesignTiles = "SearchDesignTiles",
  Studio = "Studio",
  QuantitySelectionPage = "QuantitySelectionPage",
  QuantitySelectionPageTiles = "QuantitySelectionPageTiles",
  UploadFlowDialogComponent = "UploadFlowDialogComponent",
  Discovery = "Discovery",
  PLP = "PLP",
  GalleryQuickView = "GalleryQuickView",
  Favorites = "Favorites",
  LaunchMyBusiness = "LaunchMyBusiness",
  TeamDetailsPage = "TeamDetailsPage",
  QuickProductFlowFlyout = "QuickProductFlowFlyout",
  FavoritesTemplateSection = "FavoritesTemplateSection",
}
